module.exports = __webpack_public_path__ + "cf018fdc2c1f2273a9846b50e40264f6.jpg";